import EventManager from 'dd-event-manager';
import user from './modules/user';
import device from './modules/device';
import schoolChoices from './modules/schoolChoices';
import score from './modules/score';

let $seg;
const ev = {};

new EventManager(ev);


export default {
  namespaced: true,

  state: {
    ready: false,
  },

  getters: {
    ready: state => { return state.ready },
  },

  modules: {
    user,
    device,
    schoolChoices,
    score,
  },

  actions: {
    async init({ commit, dispatch, getters, state }) {
      $seg = window.bcBanner.segments;
      await $seg.ready();
      dispatch('user/init');
      dispatch('device/init');
      dispatch('schoolChoices/init');
      dispatch('score/init');
      commit('setReady', true);
      ev.emit('init');
    },
    ready() {
      return new Promise(resolve => {
        ev.hasAndOn('init', resolve);
      });
    },
  },

  mutations: {
    setReady(state, ready) {
      state.ready = ready;
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/store/modules/segments/segments.js